import { render } from "./CardsList.vue?vue&type=template&id=4bbd8777&scoped=true"
import script from "./CardsList.vue?vue&type=script&lang=js"
export * from "./CardsList.vue?vue&type=script&lang=js"

import "./CardsList.vue?vue&type=style&index=0&id=4bbd8777&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbd8777"]])

export default __exports__